var _defs, _style, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTracabiliteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 241 241",
    width: 34,
    height: 34,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Nouveau projet") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 241,
    height: 154,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPEAAACaAQMAAABCNjzTAAAAAXNSR0IB2cksfwAAAAZQTFRFAAAABaN2n+BABwAAAAJ0Uk5TAP9bkSK1AAAB1ElEQVR4nO3XQW7CMBAFUFteZOkbNBep6mt1gZrcoFfKUXIEllSK4hI7xZPyvwdBW1EJL0DkQeL8jG1sjAmRtNmkxjjGfmHHfbzEG+77S9xzP/yMG9K67BPzNvvhWvcPvysPsepuLWjmfi0o5uE04rDHweYRh90efxwG7u747vfcmzF/h7lfzj1xb5eXN+4v6R65704nwZ4/9HVvBuZ2r/i4vLqReRbLfShXQb5emXt/kb8y9+ZP/Plaf/rnfuv9r75T/Orno9XH6gfqQ3qj9afVtzY+tPGljU9tfKvzgza/aPNT+mnHz5/mx8j714zLEjFST/NzpPnm+T1+UE/rw7tcIcD60sgOgvVp00GwvlnZQbQ+yiUOra9xUnyuexfrHkQAyFsRAHIvAkDeiACQOxEAcisCQC4DgC4CgC4CgC4CgC4CgC4CgC4CgC4CgC4CwF4CwF4CwF4CwF4CwF4CwO4Ut6eAsBvNO8WD4q3ivt5/04x1Lye6D9f2Z5pr+79f3n/euj/W9t+W+5Buk3ufY2JMg3200hzPKj2gUPL8+qNRjszLdPg9b/k8Nr4W8vbI2fPe1MPWz+utr1RH9q7qRvVQ47lSfUubqsMrJVoZHnmA1Lw3n5RvxpSZBkywAAAAAElFTkSuQmCC"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Calque 1",
    href: "#img1",
    x: 0,
    y: 43
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTracabiliteIcon);
export default __webpack_public_path__ + "static/media/Tracabilite-icon.c905b03dd357bfc753fd761758e7c478.svg";
export { ForwardRef as ReactComponent };